import React from 'react';
import { UniversityExperienceInfo, UniversityGraduatedInfo, UniversityStudentInfo, UniversityTeacherInfo } from 'icons';
import { useTranslations } from 'next-intl';

interface IProps {
  studentsCount?: string;
  graduateStudentsCount?: string;
  experienceYearsCount?: string;
  directionCount?: string;
}

const UniversityStatistics: React.FC<IProps> = ({
  studentsCount,
  graduateStudentsCount,
  experienceYearsCount,
  directionCount
}) => {
  const t = useTranslations();

  return (
    <div className="grid grid-cols-2 gap-3 rounded-xl bg-white md:grid-cols-4">
      <div className="flex items-center gap-3 rounded-xl bg-gray-50 px-4 py-3">
        <div className="text-green-600">
          <UniversityStudentInfo />
        </div>
        <div>
          <p className="text-xs text-gray-400">{t('Talaba')}</p>
          <p className="text-sm font-bold">{Number(studentsCount).toLocaleString('ru') || '-'}</p>
        </div>
      </div>
      <div className="flex items-center gap-3 rounded-xl bg-gray-50 px-4 py-3">
        <div className="text-green-600">
          <UniversityGraduatedInfo />
        </div>
        <div>
          <p className="text-xs text-gray-400">{t('Bitiruvchi')}</p>
          <p className="text-sm font-bold">{Number(graduateStudentsCount).toLocaleString('ru') || '-'}</p>
        </div>
      </div>
      <div className="flex items-center gap-3 rounded-xl bg-gray-50 px-4 py-3">
        <div className="text-green-600">
          <UniversityExperienceInfo />
        </div>
        <div>
          <p className="text-xs text-gray-400">{t('Tajriba')}</p>
          <p className="text-sm font-bold">{Number(experienceYearsCount).toLocaleString('ru') || '-'}</p>
        </div>
      </div>
      <div className="flex items-center gap-3 rounded-xl bg-gray-50 px-4 py-3">
        <div className="text-green-600">
          <UniversityTeacherInfo />
        </div>
        <div>
          <p className="text-xs text-gray-400">{t('Yonalishlar')}</p>
          <p className="text-sm font-bold">{Number(directionCount).toLocaleString('ru') || '-'}</p>
        </div>
      </div>
    </div>
  );
};

export default UniversityStatistics;
